export function evalTextAppearance(func) {
	try {
		return eval(func);
	} catch(e) {
        console.error("Got error when eval, " + func + ", " + e);
        return ''
	}
}

function digisep(string='123123123123', digits, seperator) {
	string = string.split(seperator).join("");
	const regex = new RegExp(".{" + digits + "}", "g");
	const stringParts = string.match(regex);
	if(stringParts===null) {
		return string
	}
	let valueDisplay = stringParts.join(seperator);
	const redundancy = string.replace(stringParts.join(""), "");
	if(redundancy!=="") {
		valueDisplay = valueDisplay + seperator + redundancy;
	}
	return valueDisplay;
}

export function getRows(appearances) {
	return (/\[\d+\]/g).test(appearances) ? appearances.match(/\[\d+\]/g)[0].replace(/\[|\]/g, "") : 1;
}